import React from 'react'
import { cn } from '@/lib/utils'

type IconTextProps = React.HTMLAttributes<HTMLSpanElement> & {
  icon: React.ReactNode
  text: React.ReactNode
  iconClassName?: string
  textClassName?: string
  className?: string
  gap?: 'sm' | 'md' | 'lg'
}

export const IconText = ({
  icon,
  text,
  iconClassName,
  textClassName,
  className,
  gap = 'sm',
  ...props
}: IconTextProps) => {
  const gapSize = {
    sm: 'gap-1.5',
    md: 'gap-2',
    lg: 'gap-3'
  }

  return (
    <span className={cn('inline-flex items-center', gapSize[gap], className)} {...props}>
      <span className={cn('flex items-center', iconClassName)}>
        {icon}
      </span>
      <span className={cn('text-sm font-medium leading-6', textClassName)}>
        {text}
      </span>
    </span>
  )
}
